/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AcceptTerms_viewer$ref: FragmentReference;
declare export opaque type AcceptTerms_viewer$fragmentType: AcceptTerms_viewer$ref;
export type AcceptTerms_viewer = {|
  +id: string,
  +actualPersonId: ?string,
  +hasAcceptedTerms: ?boolean,
  +$refType: AcceptTerms_viewer$ref,
|};
export type AcceptTerms_viewer$data = AcceptTerms_viewer;
export type AcceptTerms_viewer$key = {
  +$data?: AcceptTerms_viewer$data,
  +$fragmentRefs: AcceptTerms_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AcceptTerms_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAcceptedTerms",
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
// prettier-ignore
(node/*: any*/).hash = '53f4c055e162301a976503c0edb69ee9';

module.exports = node;
